import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})

export class RoleService {

	private roleSource = new BehaviorSubject<string>('General');
	public currentRole$ = this.roleSource.asObservable();

	setRole(role: string) {
		this.roleSource.next(role);
	}

}